export type ObjectBasedSchema<Schema> = object & Schema;

export type AnalyticsEvent<Schema> = {
  isFact: boolean;
  name: string;
  properties: object | ObjectBasedSchema<Schema> | null | undefined;
  referrer?: string;
  time: number;
  workspace_id?: string;
};
